module.exports = __webpack_public_path__ + "media/images/login-page-image-6c6a362b.png";